(ns practitest.frontend.common.ui
  (:require
    [cljs.pprint :as pprint]
    [reagent.dom.server :as rds]
    [reagent.core :as r]
    [goog.string :as gstring]))

(defn modal-settings [state popup-state]
  {:isOpen         (:open? popup-state)
   :onRequestClose #(swap! state assoc-in [:popup :open?] false)
   ;; this is needed for Esc and clicking outside the modal to work
   :style          {:content {:top         "20%"
                              :left        "50%"
                              :right       "auto"
                              :bottom      "auto"
                              :marginRight "-50%"
                              :transform   "translate(-50%, -50%)"}}})

(def nbsp (gstring/unescapeEntities "&nbsp;"))

(defn icon [class]
  [:i {:class (str "fa " class)}])

(defn info-tooltip-ui [{:keys [options]} & content]
  (let [{:keys [style class placement ref rel id]
         :or   {style     {:padding-bottom "2px"}
                placement "bottom"}} options]
    (r/create-class
     {:reagent-render      (fn []
                             [:i
                              {:style          style
                               :class          class
                               :data-content   (rds/render-to-static-markup
                                                (into [:<>] content))
                               :id             id
                               :data-placement placement}])
      :component-did-mount (fn [comp]
                             (let [node (js/document.getElementById id)]
                               (js-invoke (js/$ node) "popover"
                                          (clj->js {:html true :container "body"}))))})))

(defn eye-show-hide [state key label]
  [:label.pull-right.eye-show-hide
   {:on-click #(swap! state assoc key (not (key @state)))}
   nbsp
   [:i.eye-show-hide
    {:type  "button"
     :class (if (key @state) "fa fa-eye" "fa fa-eye-slash")
     :value (key @state)}]
   label])

